<template lang="pug">
  #order-detail-list
    .form-inline(:class="customer_service_title_class")
      h5.font-weight-bold.mb-0 ご注文明細
        template(v-if="contract_type === 1") （年額でのお支払い時）
        template(v-else) （月額でのお支払い時）
      b-form-text ※金額は税込表示です。
    b-table-simple.ml-3.rounded.table-style(small, responsive="responsive", bordered)
      b-tbody
        b-tr
          b-td
          b-td.table-quantity-size
            b-form-text.font-weight-bold 数量
          b-td.table-initial-size
            b-form-text.text-right.font-weight-bold 初期費用
          b-td.table-monthly_size
            b-form-text.text-right.font-weight-bold
              template(v-if="contract_type === 1") 年額費用
              template(v-else) 月額費用
        b-tr(v-for="(item, key) of activePaymentDetails", :key="key", :class="bgColors[item.type]")
          b-td
            b-form-text.font-weight-bold
              | {{item.name}}
              template(v-if="item.name === 'タイムカード＋CLOUZA' && register_data.neo.option.clouza.paid_leave_option") （有休管理＋申請承認オプション）
              template(v-if="item.name === 'クライアント認証' && register_data.neo.security.client.cert_except_ip") （認証を除外するIPアドレスを設定する）
              template(v-if="item.name === 'クライアント認証' && !register_data.neo.security.client.cert_except_ip") （認証を除外するIPアドレスを設定しない）
              template(v-if="register_data.estimate") （※お見積書の内容に準じます。）
          b-td
            b-form-text(v-if="register_data.estimate") - -
            b-form-text(v-else-if="isDisk(item.name)") {{item.unit}} {{item.count}}
            b-form-text(v-else-if="item.name === '情報漏えい対策' || item.name === '添付ファイル暗号化・分離' || item.name === 'メールアーカイブ＆監査' || item.name === 'クラウド型サンドボックス'")
            b-form-text(v-else) {{item.count}} {{item.unit}}
          b-td
            b-form-text.text-right(v-if="register_data.estimate") - -
            b-form-text.text-right(v-else) {{showPriceNumber(item.initial_cost)}}
          b-td
            b-form-text.text-right(v-if="register_data.estimate") - -
            b-form-text.text-right(v-else) {{showPriceNumber(getTotalCostPerItem(item))}}
        b-tr
          b-td
           b-form-text 計
          b-td
           b-form-text - -
          b-td
            b-form-text.text-right {{sumInitialCost}}
          b-td
            b-form-text.text-right {{sumMonthlyCost}}
    template(v-if="show_notice.plan === true")
      b-form-text.ml-3.plan-title-bg-color ※ご利用になるプランの明細です。
    template(v-if="show_notice.neo === true")
      b-form-text.ml-3.neo-title-bg-color ※desknet's NEOの明細です
    template(v-if="show_notice.chat === true")
      b-form-text.ml-3.chat-title-bg-color ※ChatLuckの明細です
</template>

<script>
export default {
  name: 'PaymentDetailList',
  props: {
    register_data: { type: Object, required: true},
    show_notice: { type: Object, required: false, Default: {} },
    contract_type: { type: Number, required: false, Default: 0 },  // ご契約種別(0:月払い、1:年間一括払い)
  },
  data() {
    return {
      customer_service_title_class: "font-weight-bold ml-3 border-top border-bottom py-2 customer-title-bg-color",

      // 明細の背景色
      bgColors: {
        'plan': 'plan-title-bg-color',
        'neo': 'neo-title-bg-color',
        'chat': 'chat-title-bg-color',
      },

      // 明細に表示する項目
      payment_details: this.returnPaymentDetails()
    }
  },
  created() {
    // ご注文明細の数値を生成する
    // プラン
    if (this.register_data.plan) {
      // ライトプランの場合
      if (this.register_data.plan.type === 'light') {
        this.payment_details.light.count = this.register_data.plan.user
      }
      // スタンダードプランの場合
      if (this.register_data.plan.type === 'standard') {
        this.payment_details.standard.count = this.register_data.plan.user
      }
      // プレミアムプランの場合
      if (this.register_data.plan.type === 'premium') {
        this.payment_details.premium.count = this.register_data.plan.user
      }
      // チャットプラスプランの場合
      if (this.register_data.plan.type === 'chatplus') {
        this.payment_details.chatplus.count = this.register_data.plan.user
      }
    }
    // NEO
    if (this.register_data.neo) {
      // AppSuiteユーザー数
      this.payment_details.app_suite_user.count = this.register_data.neo.app_suite_user
      // ウェブ会議
      this.payment_details.web_conferencing.count = this.register_data.neo.web_conferencing
      // NEO オプション
      if (this.register_data.neo.option) {
        // RoomMgr
        if (this.register_data.neo.option.room_mgr === true) {
          this.payment_details.room_mgr.count = 1
        }
        // 交通費・経費精算
        if (this.register_data.neo.option.expense_settlement === true) {
          this.payment_details.expense_settlement.count = this.register_data.plan.user
        }
        if (this.register_data.neo.option.clouza) {
          // タイムカード＋CLOUZA
          this.payment_details.clouza.count = this.register_data.neo.option.clouza.user
          // 有休管理＋申請承認オプション
          if (this.register_data.neo.option.clouza.paid_leave_option === true) {
            this.payment_details.clouza.monthly_unit_cost = 2200 + 1650
          }
        }
        // ディスク増設
        this.payment_details.neo_disk_size.count = this.register_data.neo.option.disk ? this.register_data.neo.option.disk.disk_size : 0
        // Sync for smartphones
        this.payment_details.sync.count = this.register_data.neo.option.sync ? this.register_data.neo.option.sync.user : 0
        // desknet'sドライブ ディスク増設
        this.payment_details.dn_drive_disk_size.count = this.register_data.neo.option.dn_drive ? this.register_data.neo.option.dn_drive.disk_size : 0
      }
      // NEO セキュリティ
      if (this.register_data.neo.security) {
        // セキュアブラウザ
        if (this.register_data.neo.security.secure) {
          // 端末認証の有無によって用いる個数と明細情報が頃なる
          if ( this.register_data.neo.security.secure.secure_browser_terminal === '01') {
            // 端末認証なしの場合はプランユーザー数を個数とする
            this.payment_details.secure_browser_terminal_off.count = this.register_data.plan.user
          }
          else if ( this.register_data.neo.security.secure.secure_browser_terminal === '02') {
            // 端末認証ありの場合はデバイス数を個数とする
            this.payment_details.secure_browser_terminal_on.count = this.register_data.neo.security.secure.secure_browser_device || 0
          }
        }
        // クライアント認証
        this.payment_details.client_auth.count = this.register_data.neo.security.client ? this.register_data.neo.security.client.device : 0
      }
      // NEO メール
      if (this.register_data.neo.mail) {
        // メールサービス（WebARENA）
        this.payment_details.web_arena.count = this.register_data.neo.mail.arena ? this.register_data.neo.mail.arena.account : 0
        // メールサービス（CYBERMAILΣ）
        if (this.register_data.neo.mail.cyber) {
          // ユーザー数
          this.payment_details.cyber_account.count = this.register_data.neo.mail.cyber.account || 0
          // 単価は容量によって変わる
          // TODO: 容量毎にpayment_detailsの要素にした方がよいか
          switch (this.register_data.neo.mail.cyber.mailbox) {
            case '02':
              this.payment_details.cyber_account.monthly_unit_cost = 275
              break
            case '03':
              this.payment_details.cyber_account.monthly_unit_cost = 440
              break
            case '04':
              this.payment_details.cyber_account.monthly_unit_cost = 550
              break
            default:
          }
          // CYBERMAILΣ オプション
          const cyber_option = this.register_data.neo.mail.cyber.options
          const cyber_account = this.register_data.neo.mail.cyber.account || 0
          // 情報漏えい対策
          this.payment_details.cyber_dlp.count = cyber_option.indexOf('00') !== -1 ? cyber_account : 0
          // 添付ファイル暗号化・分離
          this.payment_details.cyber_dlp_separation.count = cyber_option.indexOf('01') !== -1 ? cyber_account : 0
          // メールアーカイブ＆監査
          if (cyber_option.indexOf('02') !== -1) {
            // 数量
            this.payment_details.cyber_archive.count = cyber_account
            // 単価は保存期間によって変わる
            switch (this.register_data.neo.mail.cyber.keep) {
              case '02':
                this.payment_details.cyber_archive.monthly_unit_cost = 440
                break
              default:
            }
          }
          // クラウド型サンドボックス
          this.payment_details.cyber_sandbox.count = cyber_option.indexOf('03') !== -1 ? cyber_account : 0
        }
      }

      // NEO メールセキュリティ
      if (this.register_data.neo.mail_security) {
        // メールセキュリティサービス（MAILGATES Σ）
        if (this.register_data.neo.mail_security.mailgates) {
          const mailgates_account = this.register_data.neo.mail_security.mailgates.account
          const mailgates_option = this.register_data.neo.mail_security.mailgates.options

          // 初期費用
          this.payment_details.mailgates_init.count = 1
          // アンチウイルス・スパム＋サンドボックス
          this.payment_details.mailgates_antivirus_sandbox.count = mailgates_option.indexOf('01') !== -1 ? mailgates_account : 0
          // 誤送信対策・審査
          this.payment_details.mailgates_prevent_missend.count = mailgates_option.indexOf('02') !== -1 ? mailgates_account : 0
          // 添付ファイル暗号化・分離
          this.payment_details.mailgates_separation.count = mailgates_option.indexOf('03') !== -1 ? mailgates_account : 0
        }
      }
    }
    // ChatLuck
    if (this.register_data.chat) {
      // ChatLuck
      this.payment_details.chat_user.count = this.register_data.chat.chat_user
      // ディスク増設
      if (this.register_data.chat.option && this.register_data.chat.option.disk) {
        this.payment_details.chat_disk_size.count = this.register_data.chat.option.disk.disk_size
      }
    }
  },
  methods: {
    // ご注文明細の合計の金額に表示する文字列を生成する
    getSumCostString(sumCost) {
      // 0円になる場合は「- -」で表示する
      let showCost = '- -'
      if (sumCost > 0) {
        showCost = this.showPriceNumber(sumCost)
      }

      return showCost
    },
    // 商品毎の料金を計算して取得する
    getTotalCostPerItem(item) {
      let costPerOne = item.monthly_unit_cost  // 費用(1単位当たり)
      let count = item.count  // 個数

      // タイムカード＋CLOUZAの料金は10人単位なので、個数を1/10にして計算する
      if (item.name === 'タイムカード＋CLOUZA') {
        count = item.count / 10
      }

      // 年間一括払いの場合
      if (this.contract_type === 1) {
        // ディスク増設の場合は月額と年額で月当たりの料金が異なる
        // ※NEOとchat両方共通
        if (item.name === 'ディスク増設') {
          costPerOne = item.yearly_unit_cost
        }
        else {
          costPerOne = costPerOne * 12
        }
      }

      // 合計の費用を取得する
      return costPerOne * count
    },
    /**
     * ディスク増設の商品か確認する
     *
     * @param item_name 商品名
     * @return true: ディスク増設の商品 false: ディスク増設の商品ではない
     */
    isDisk(item_name) {
      return item_name === 'ディスク増設' || item_name === "desknet'sドライブ ディスク増設";
    }
  },
  computed: {
    // ご注文明細に表示する注文を抽出する
    activePaymentDetails() {
      const selectedItems = [];

      // 各キーに対して繰り返し処理を行う
      for (let key in this.payment_details) {
        // 選択されている商品のみを表示する
        if (this.payment_details[key].count > 0) {
          // 配列に追加する
          selectedItems.push(this.payment_details[key]);
        }
      }

      // 選択されている商品を返す
      return selectedItems;
    },
    // ご注文明細の初期費用の合計
    sumInitialCost() {
      let sum_cost = 0
      for (let detail of this.activePaymentDetails) {
        // お見積番号が入力されている場合は加算しない
        sum_cost += this.register_data.estimate ? 0 : detail.initial_cost
      }

      return this.getSumCostString(sum_cost)
    },
    // ご注文明細の月額費用の合計
    sumMonthlyCost() {
      let sum_cost = 0
      for (let detail of this.activePaymentDetails) {
        // お見積番号が入力されている場合は加算しない
        if (this.register_data.estimate) {
          continue
        }

        // 商品の年額または月額を加算する
        sum_cost += this.getTotalCostPerItem(detail)
      }

      return this.getSumCostString(sum_cost)
    },
  },
}
</script>

<style scoped>
.plan-title-bg-color {
  background-color: #fceaee;
}
.neo-title-bg-color {
  background-color: #f2ffff;
}
.chat-title-bg-color {
  background-color: #f0ffe0;
}
.customer-title-bg-color {
  background-color: #f5f5f5;
}
.table-quantity-size {
  width: 100px;
}
.table-initial-size {
  width: 100px;
}
.table-monthly_size {
  width: 100px;
}
.table-style {
  width: 686px;
}
</style>
